import * as R from 'ramda'
import { createSelector } from 'reselect'
import {
  GetEnvironment,
  GetLoggedIn,
  GetMemberInfos,
  GetMemberLoggingIn,
  GetMemberState,
  GetRankingUrl,
  GetVersion
} from 'store/selectors/member.types'

export const getMemberState: GetMemberState = R.prop('member')

const getMemberInfos: GetMemberInfos = createSelector(
  getMemberState,
  R.prop('memberInfo')
)

export const getLoggedIn: GetLoggedIn = createSelector(
  getMemberState,
  R.prop('loggedIn')
)

export const getMemberLoggingIn: GetMemberLoggingIn = createSelector(
  getMemberState,
  R.prop('loggingIn')
)

export const getEnvironment: GetEnvironment = createSelector(
  getMemberState,
  R.prop('env')
)

export const getVersion: GetVersion = createSelector(
  getMemberState,
  R.prop('version')
)

export const getMemberId = createSelector(
  getMemberInfos,
  R.prop('memberId')
)

export const getRankingUrl: GetRankingUrl = createSelector(
  getMemberState,
  member => member?.rankingStatementPdfFileUrl
)
